
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { ComponentsModule } from '../../shared/components/components.module';

@Component({
  selector: 'app-ratgeber-standort-page',
  imports: [ComponentsModule],
  templateUrl: './ratgeber-standort-page.component.html',
  styleUrl: './ratgeber-standort-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatgeberStandortPageComponent {
  index = 0;
  content;
  active = new Array(23).fill(true);
  constructor(
    private route: ActivatedRoute,
    private metaTagService: Meta,
    private titleService: Title
  ) {
    this.content = this.route.snapshot.data.content;
    this.titleService.setTitle(this.content.title);
    this.metaTagService.updateTag(
      { name: 'description', content: this.content.description },
      'name=description'
    );
  }

  ngOnInit(): void { }

  toggleActive(index) {
    this.active[index] = !this.active[index];
  }
  getIndex(isFirst?) {
    if (isFirst) {
      this.index = 0;
    }
    return this.index++;
  }
}
